import {ApiResponse} from "../models/ApiResponse";
import MainBackendAxios from "../utils/MainBackendAxios";
import {FunctionsHelper} from "../utils/FunctionsHelper";
import {PromotionalMaterial} from "../models/PromotionalMaterial";

export const PromotionalMaterialService = {
    getAll: async (): Promise<ApiResponse<PromotionalMaterial[]>> => {
        try {
            const response = await MainBackendAxios.get(`/promotional-material/get-all`);

            return {
                success: true,
                status: response.status,
                data: response?.data?.data,
            };
        } catch (err: any) {
            return FunctionsHelper.getErrorFormat(err);
        }
    },
};
